import { c as _c } from "react/compiler-runtime";
import { format } from 'date-fns';
export type TimelineItemTimeProps = {
  timestamp: string;
  timeOnly?: boolean;
};
const TimelineItemTime = t0 => {
  const $ = _c(10);
  const {
    timestamp,
    timeOnly
  } = t0;
  let t1;
  if ($[0] !== timeOnly || $[1] !== timestamp) {
    t1 = !timeOnly && <p className="text-snippet-2 text-tertiary fp-text">{format(new Date(timestamp), "MM/dd/yy")}</p>;
    $[0] = timeOnly;
    $[1] = timestamp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== timestamp) {
    t2 = format(new Date(timestamp), "hh:mm a");
    $[3] = timestamp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className="text-snippet-2 text-tertiary fp-text">{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="flex flex-row items-center justify-start gap-0.5 mr-0.5 [&_p]:min-w-[72px]">{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default TimelineItemTime;